export const nationalDigits = (phone?: string | null) =>
    (phone || '').replace(/\D/g, '')

export const sameNationalPhone = (
    left?: string | null,
    right?: string | null
) => {
    const leftDigits = nationalDigits(left)
    const rightDigits = nationalDigits(right)
    return Boolean(leftDigits) && leftDigits === rightDigits
}

export const isUnknownVillageName = (villageName?: string | null) => {
    if (!villageName?.trim()) return true
    return villageName.toLowerCase().includes('unknown')
}

export const canOpenPhoneLookupMatch = (
    client: { village?: string | null; village_id?: string },
    assignedVillageIds: string[]
) => {
    if (isUnknownVillageName(client.village)) return true
    if (!client.village_id) return false
    return assignedVillageIds.includes(client.village_id)
}
